import React from 'react';

const Education = () => {
  const educations = [
    {
      degree: 'Bachelor of Technology (B. Tech)',
      institution: 'RGVP University',
      duration: '2014 - 2018',
      grade: 'CGPA: 7.6',
      description: 'Comprehensive study of computer science fundamentals, programming languages, and database management systems.',
      achievements: [
        'First class graduate',
        'President of Computer Science Club',
        'Winner of inter-college coding competition'
      ]
    },
    {
      degree: 'Higher Secondary Education',
      institution: 'Madhya Pradesh Board of Secondary Education',
      duration: '2014 - 2018',
      grade: 'Percentage: 85%',
      description: 'Completed higher secondary education with focus on Science and Mathematics.',
      achievements: [
        'School topper in Mathematics',
        'Active participant in science exhibitions'
      ]
    }
  ];

  const certifications = [
    {
      name: 'AWS Certified Solutions Architect',
      issuer: 'Amazon Web Services',
      date: '2023'
    },
    {
      name: 'React - The Complete Guide',
      issuer: 'Udemy',
      date: '2022'
    },
    {
      name: 'Full Stack Web Development',
      issuer: 'Coursera',
      date: '2021'
    }
  ];

  return (
    <section className="education-section" id="education">
      <div className="section-header" data-aos="fade-up">
        <h2 className="section-title">Education & Certifications</h2>
        <p className="section-subtitle">
          Academic background and professional certifications
        </p>
      </div>

      <div className="education-content">
        <div className="education-column">
          <h3 className="column-title" data-aos="fade-up">
            <i className="ph ph-graduation-cap"></i>
            Education
          </h3>
          <div className="education-timeline">
            {educations.map((edu, index) => (
              <div 
                key={index} 
                className="education-card" 
                data-aos="fade-up" 
                data-aos-delay={index * 100}
              >
                <div className="education-header">
                  <div className="education-title-group">
                    <h4 className="education-degree">{edu.degree}</h4>
                    <p className="education-institution">
                      <i className="ph ph-student"></i>
                      {edu.institution}
                    </p>
                  </div>
                  <div className="education-meta">
                    <span className="education-duration">
                      <i className="ph ph-calendar"></i>
                      {edu.duration}
                    </span>
                    <span className="education-grade">{edu.grade}</span>
                  </div>
                </div>
                <p className="education-description">{edu.description}</p>
                <ul className="education-achievements">
                  {edu.achievements.map((achievement, idx) => (
                    <li key={idx}>
                      <i className="ph ph-medal"></i>
                      {achievement}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="certifications-column">
          <h3 className="column-title" data-aos="fade-up">
            <i className="ph ph-certificate"></i>
            Certifications
          </h3>
          <div className="certifications-list">
            {certifications.map((cert, index) => (
              <div 
                key={index} 
                className="certification-card" 
                data-aos="fade-up" 
                data-aos-delay={index * 100}
              >
                <div className="cert-icon">
                  <i className="ph ph-seal-check"></i>
                </div>
                <div className="cert-content">
                  <h4 className="cert-name">{cert.name}</h4>
                  <p className="cert-issuer">{cert.issuer}</p>
                  <span className="cert-date">{cert.date}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
